import Button from '../Buttons/Button';
import styles from './UserPlan.module.scss';

interface UserPlanProps {
	planName: string;
	totalPlans?: number;
	yourPlans?: number;
	showUpgradeButton?: boolean;
}

export default function UserPlan({ planName, totalPlans, yourPlans, showUpgradeButton = true }: UserPlanProps) {
	const showStatistic = totalPlans !== undefined && yourPlans !== undefined;
	let used = yourPlans || 0;
	if (showStatistic && totalPlans < yourPlans) {
		used = totalPlans;
	}
	return (
		<div className={styles.plan}>
			<div className={styles.title}>{planName}</div>
			{showStatistic && <div className={styles.stats}>
				<div className={styles.info}>
					Report used <span className={styles.count}>{used} of {totalPlans}</span>
				</div>
				<div
					className={styles.bar}
					style={{
						background: `linear-gradient(to right, var(--violet) ${(used / totalPlans) * 100}%, var(--grayLight) ${(yourPlans / totalPlans - 1) * 100}%)`,
					}}
				/>
			</div>
			}
			{showUpgradeButton && <div className={styles['button-wrap']}>
				<Button
					variant="filled"
					color="primary"
					data-mode="popup"
					data-submit-close-delay="2"
					sizeWidth="full"
				>
					Upgrade
				</Button>
			</div>}
		</div>
	);
}
